import UpIcons from '@/icons/UpIcons'
import { useTranslation } from 'react-i18next'
import { Button } from 'vnetwork-ui'

const ExportComponent = () => {
    const { t } = useTranslation()
    return (
        <Button
            size="small"
            endIcon={<UpIcons />}
            variant="contained"
            className="h-10 mt-2"
        >
            {t('contract-export')}
        </Button>
    )
}

export default ExportComponent
